// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"payment-providers_wrapper__DOlhX","googleRating":"payment-providers_googleRating__cgaOQ","link":"payment-providers_link__6VBw7"};